import React from 'react'
import { Link } from 'react-router-dom'

const Doors = ( {oldWorldDoorPhotos, modernDoorPhotos} ) => {
    return (
        <div>
            <div className='product-header'>
                <Link to='/' style={{ textDecoration: 'none' }}>
                    <h2>Home</h2>
                </Link>
                <h1>Doors</h1>           
            </div>
            <div className='product-description'>
                <p>Old world hand carved doors and new world contemporary/modern doors. If you can dream it, we can build it.</p>
            </div>
                <h2>Old World Doors</h2>
            <div className='all-products'>
            {oldWorldDoorPhotos.map((image, index) => (
                <div className='product-item' key = {image}>
                    <img src={image} key={index} alt={`Image ${index}`} width="300"/>
                </div>
            ))}
            </div>
                <h2>Modern Doors</h2>
            <div className='all-products'>
            {modernDoorPhotos.map((image, index) => (
                <div className='product-item' key = {image}>
                    <img src={image} key={index} alt={`Image ${index}`} width="300"/>
                </div>
            ))}
            </div>
        </div>
      );
}

export default Doors;